import { createStyles, makeStyles } from '@material-ui/core/styles';
import { DARK_GRAY } from 'constants/colors';
export default makeStyles(theme => {
  return createStyles({
    listItem: {
      margin: theme.spacing(1, 0),
      listStyle: 'none',
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
      textAlign: 'left',
      wordBreak: 'break-all'
    },
    listItemTitle: {
      maxWidth: `calc(50% - 16px)`,
      marginRight: theme.spacing(2)
    },
    listItemSubtitle: {
      width: '50%',
      fontWeight: 'normal',
      color: DARK_GRAY
    },
    listItemDense: {
      margin: 0
    }
  });
});